import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from '../../../hook/use-http';
import moment from 'moment';
import { ThreeCircles } from 'react-loader-spinner';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
import { event, $ } from "jquery";

import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice"

const TOP_KPIS_SECOND_PAGE_MAIN = {
  discharge_cycle: 0,
  distance_travelled: 0,
  distance_travelled_start: 0,
  distance_travelled_end: 0,
  per_idel_time: 0,
  avg_discharge_cycle: 0,
  mean_range: 0,
  mean_whr: 0,
  avg_cusumption_cycle: 0,
};

function TopkpisSecondMain_Jupiter({ gloablfilter, apiend }) {
  const [topdata, setTopData] = useState(TOP_KPIS_SECOND_PAGE_MAIN);
  const [modaldata, setModaldata] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [total_km_value, setCommas] = useState();
  const [distance_travelled_start, setStartdate] = useState();
  const [distance_travelled_end, setEnddate] = useState();
  const [currentRadioValue, setCurrentRadioValue] = useState("discharge")

  const appyData = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result[0];
      responce = {
        discharge_cycle: temp_result.doc_count,
        distance_travelled: temp_result.distanceInKM.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        distance_travelled_start: ((temp_result.startOdo.value) != null) ? (temp_result.startOdo.value) : 0,
        distance_travelled_end: ((temp_result.endOdo.value) != null) ? (temp_result.endOdo.value) : 0,
        per_idel_time: (temp_result.per_idle_time.value != null && temp_result.per_idle_time.value != 0) ? ((temp_result.per_idle_time.value) / 3600).toFixed(2) : 0,
        avg_discharge_cycle: (temp_result.avg_disc_cycle.values["50.0"] != null) ? (temp_result.avg_disc_cycle.values["50.0"]).toFixed(2) : 0,
        mean_range: (temp_result.mean_range.values["50.0"] != null) ? (temp_result.mean_range.values["50.0"]).toFixed(2) : 0,
        mean_whr: (temp_result.mean_whkm.values["50.0"] != null) ? (temp_result.mean_whkm.values["50.0"]).toFixed(2) : 0,
        avg_cusumption_cycle: (temp_result.medianConsumptionCycle.values["50.0"] != null) ? (temp_result.medianConsumptionCycle.values["50.0"]).toFixed(2) : 0
      }
      setTopData((prestate) => responce);
    }
  }

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter } }, appyData)
  }, [gloablfilter])

  let loader = (<div style={{ margin: "auto" }}><ThreeCircles
    height="50"
    width="40"
    wrapperStyle={{}}
    wrapperClass=""
    visible={true}
    ariaLabel="three-circles-rotating"
    outerCircleColor="#3498db"
    innerCircleColor="#dec52d"
    middleCircleColor="#db213a"
  /></div>)

  const appyDataModal = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;
      setModaldata(temp_result);
    } else {
      setModaldata([]);
    }
  }

  const loadModalData = () => {
    setCurrentRadioValue("discharge")
    fetchData({ url: API_URL_MAIN + "drivesecondpage/dischargecycleModal", body: { filterdata: gloablfilter } }, appyDataModal)
    window.$("#Dischargecycles").addClass("active")
    window.$("#outliers").removeClass("active")
  }

  const handleRadioChange = (e) => {
    setCurrentRadioValue(e.target.value);
  };
  const handlePlatformChange = (event) => {
    const toggel = event.target.innerText
    if (toggel === "Discharge cycles")
      fetchData({ url: API_URL_MAIN + "drivesecondpage/dischargecycleModal", body: { filterdata: gloablfilter } }, appyDataModal)
    else
      fetchData({ url: API_URL_MAIN + "drivesecondpage/outliers", body: { filterdata: gloablfilter } }, appyDataModal)
  }

  const loggedInUser = useSelector(selectLoggedInUser);
  let divAttributes = {};
  if (loggedInUser.flagForHideShow === "ERC") {
    divAttributes["data-bs-toggle"] = 'modal';
    divAttributes["data-bs-target"] = '#staticBackdrop';
    divAttributes.onClick = { loadModalData };
  } else {
    divAttributes = divAttributes;
  }

  return (
    <>
      <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <div style={{ marginLeft: "2%" }} className="btn-group btn-group-toggle" data-toggle="buttons" onClick={handlePlatformChange} >
                <label className="btn btn-infotable active" id="Dischargecycles">
                  <input type="radio" name="platform" value="Discharge cycles" autoComplete="off" /> Discharge cycles
                </label>
                <label className="btn btn-infotable" id="outliers">
                  <input type="radio" name="platform" value=" Outliers" autoComplete="off" /> Outliers
                </label>
              </div>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="tablecontainer" style={{ overflowX: "scroll", minHeight: "300px" }}>
                <table className="table table-striped" style={{ width: "1500px" }}>
                  <thead style={{ backgroundColor: '#32879c', color: '#fff', position: "sticky", top: 0, zIndex: 0 }}>
                    <tr>
                      <th scope="col">Cycle</th>
                      <th scope="col">Start Time</th>
                      <th scope="col">End Time</th>
                      <th scope="col">Soc Start</th>
                      <th scope="col">Soc End</th>
                      <th scope="col">Discharge</th>
                      <th scope="col">ODO Start</th>
                      <th scope="col">ODO End</th>
                      <th scope="col">Distance Travelled (Km)</th>
                      <th scope="col">Delta DTE (km)</th>
                      <th scope="col">Error DTE</th>
                      <th scope="col">Range</th>
                      <th scope="col">kWh</th>
                      <th scope="col">Wh/km</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? loader : (modaldata.length == 0) ? <tr><td colSpan='17' className="alert alert-danger no_data" style={{ background: "#f4c2ce" }}>No records found</td></tr> : modaldata.map((x, index) => {
                      return (<tr key={index}>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{index + 1}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{moment(new Date(x._source.startTime)).format("YYYY-MM-DD HH:mm:ss")}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{moment(new Date(x._source.endTime)).format("YYYY-MM-DD HH:mm:ss")}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.startSoc}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.endSoc}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.dischargeSoc}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.startOdo}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.endOdo}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.distanceInKM}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{x._source.deltaDte}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{isNaN(parseInt(x._source.errorDte)) ? "null" : parseFloat(x._source.errorDte.toFixed(2))}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{isNaN(parseInt(x._source.Range)) ? "null" : parseFloat(x._source.Range.toFixed(2))}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{isNaN(parseInt(x._source.NetkWh)) ? "null" : parseFloat(x._source.NetkWh.toFixed(2))}</td>
                        <td scope="row " style={{ padding: "3px", textAlign: "center" }}>{isNaN(parseInt(x._source.whPerKM)) ? "null" : parseFloat(x._source.whPerKM.toFixed(2))}</td>
                      </tr>)
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="kpi my-3">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-12 col-lg-8 pl-0">
            <div className="row">
              <div className={(loggedInUser.flagForHideShow === "ERC" ? "col-md-3 col-sm-6 col-6 pl-0 mb-1 evtpks-pl0" : "col-md-4 col-sm-12 col-12 pl-0 mb-1 evtpks-pl0")}>
                <div className="widget p-2 py-4 d-flex align-items-center" style={{ marginLeft: "6%", height: "100px" }}>
                  <div className="widgetIcon widgetIcon_"><img src={"/assets/img/charging-station-2.png"} /> </div>
                  {
                    loggedInUser.flagForHideShow === "ERC" ?
                      <div className="pl-3" data-bs-toggle="modal" data-bs-target="#staticBackdrop" style={{ cursor: "pointer" }} onClick={loadModalData}>
                        <div className="ps-0">
                          <p className="h5 mt-2 mb-0">0</p>
                          <p className="m-0"><small className="text-muted">Discharge Cycle</small></p>
                        </div>
                      </div> :
                      <div className="pl-3">
                        <div className="ps-0">
                          <p className="h5 mt-2 mb-0">0</p>
                          <p className="m-0"><small className="text-muted">Discharge Cycle</small></p>
                        </div>
                      </div>
                  }
                </div>
              </div>
              <div className={(loggedInUser.flagForHideShow === "ERC" ? "col-md-3 col-sm-6 col-6 pl-0 mb-1 evtpks-pl0" : "col-md-4 col-sm-12 col-12 pl-0 mb-1 evtpks-pl0")}>
                <div className="widget p-2 py-4 d-flex align-items-center" style={{ height: "100px" }}>
                  <div className="widgetIcon_ widgetIcon"><img src={"/assets/img/charging-1.png"} />
                  </div>
                  <div className="pl-3" style={{ width: '74%', display: 'inline-block' }}>
                    <div>
                      <div className="fst" style={{ borderBottom: 'none', marginRight: "1px", float: 'right', fontSize: "10px" }}>
                        <b style={{ borderBottom: 'solid 2px #ffa650' }} className="charging_cy" id="charging_cy_fast">{topdata.distance_travelled_start}</b> Start
                      </div>
                      <div className="sl" style={{ borderBottom: 'none', fontSize: "10px" }}>
                        <b style={{ borderBottom: 'solid 2px #1494ac' }} className="charging_cy" id="charging_cy_slow">{topdata.distance_travelled_end}</b> End
                      </div>
                      <p className="h5 mt-2 mb-0">0</p>
                      <p className="m-0"><small className="text-muted">Distance Travelled</small></p>
                    </div>
                  </div>
                </div></div>

              <div className={(loggedInUser.flagForHideShow === "ERC" ? "col-md-3 col-sm-6 col-6 pl-0 mb-1 evtpks-pl0" : "col-md-4 col-sm-12 col-12 pl-0 mb-1 evtpks-pl0")}>
                <div className="widget p-2 py-4 d-flex align-items-center" style={{ height: "100px" }}>
                  <div className="widgetIcon_ widgetIcon"><img src={"/assets/img/electric-1.png"} /> </div>
                  <div className="ps-3">
                    <p className="h5 mt-2 mb-0">0</p>
                    <p className="m-0"><small className="text-muted">Percentage idle time</small></p>
                  </div>
                </div>
              </div>
              {
                loggedInUser.flagForHideShow === "ERC" &&
                <div className="col-md-3 col-sm-6 col-6 pl-0 mb-1 evtpks-pl0">
                  <div className="widget p-2 py-4 d-flex align-items-center" style={{ height: "100px" }}>
                    <div className="widgetIcon_ widgetIcon"><img src={"/assets/img/battery-charge-1.png"} /> </div>
                    <div>
                      <p className="h5 mt-2 mb-0">0</p>
                      <p className="m-0"><small className="text-muted">Median discharge/cycle</small></p>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          <div className="col-md-12 col-sm-12 col-12 col-lg-4 pl-0 evtpks-pl0">
            <div className="widget">
              <div className="row">
                <div className={(loggedInUser.flagForHideShow === "ERC" ? "col-md-4 col-sm-4 bt-graph" : "col-md-6 col-sm-6 bt-graph")} style={{ height: "100px" }}>
                  <div className="text-center mt-3">
                    <div className="widgetIcon-32"><img src={"/assets/img/electric-car-4.png"} /> </div>
                    <div className="mt-1">
                      <p className="h5 mt-1 mb-0">0</p>
                      <p className="m-0"><small className="text-muted">Median range</small></p>
                    </div>
                  </div>
                </div>
                <div className={(loggedInUser.flagForHideShow === "ERC" ? "col-md-4 col-sm-4 bt-graph" : "col-md-6 col-sm-6 bt-graph")} style={{ height: "100px" }}>
                  <div className="text-center mt-3">
                    <div className="widgetIcon-32"><img src={"/assets/img/location-1-1.png"} /> </div>
                    <div className="mt-1">
                      <p className="h5 mt-1 mb-0">0</p>
                      <p className="m-0"><small className="text-muted">Median Wh/km</small></p>
                    </div>
                  </div>
                </div>
                {
                  loggedInUser.flagForHideShow === "ERC" &&
                  <div className="col-md-4 col-sm-4" style={{ height: "100px" }}>
                    <div className="text-center mt-1" style={{ marginLeft: 0 }}>
                      <div className="widgetIcon-32"><img src={"/assets/img/average-1.png"} /> </div>
                      <div className="mt-1">
                        <p className="h5 mt-1 mb-0"> 0 </p>
                        <p className="m-0"><small className="text-muted">Median consumption/cycle</small></p>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TopkpisSecondMain_Jupiter;
